import React from "react"
import MojoMiniLogo from "url:assets/images/mojo-mini-logo-alt.svg"
import { ConveyancingCardComponent } from "./components/ConveyancingCard"
import { OfferAcceptedHeader } from "./components/OfferAcceptedHeader"
import { CallbackConfirmationCard } from "./components/CallbackConfirmationCard"
import { SpeedUpApplicationCard } from "./components/SpeedUpApplicationCard"
import { StatusContainer, HeaderSection } from "./shared/StyledComponents"
import { StatusData } from "./utils/statusApiUtils"

interface OfferAcceptedBookedViewProps {
  fetchedStatus?: StatusData | null
  friendlyId: string
  appointmentDate?: Date
}

export const OfferAcceptedBookedView: React.FC<OfferAcceptedBookedViewProps> = ({
  fetchedStatus,
  friendlyId,
  appointmentDate,
}) => {
  const mortgageExpert = {
    name: fetchedStatus?.opportunityOwnerTextForEmail || "Mojo Mortgages",
    title: fetchedStatus?.flexRoles2 || "Mortgage Expert",
    email: fetchedStatus?.ownerEmailAddress || "",
    avatar: MojoMiniLogo,
  }

  return (
    <StatusContainer>
      <HeaderSection>
        <OfferAcceptedHeader />
      </HeaderSection>

      <CallbackConfirmationCard
        mortgageExpert={mortgageExpert}
        appointmentDate={appointmentDate}
        fetchedStatus={fetchedStatus}
      />

      <SpeedUpApplicationCard friendlyId={friendlyId} />

      <ConveyancingCardComponent friendlyId={friendlyId} />
    </StatusContainer>
  )
}
